
interface RetreatFiltersProps {
  selectedType: string;
  setSelectedType: (type: string) => void;
  selectedDuration: string;
  setSelectedDuration: (duration: string) => void;
}

export default function RetreatFilters({ 
  selectedType, 
  setSelectedType, 
  selectedDuration, 
  setSelectedDuration 
}: RetreatFiltersProps) {
  const types = [
    { value: 'all', label: 'All Types' },
    { value: 'wellness', label: 'Wellness' },
    { value: 'adventure', label: 'Adventure' },
    { value: 'culinary', label: 'Culinary' },
    { value: 'creative', label: 'Creative' },
    { value: 'romantic', label: 'Romantic' }
  ];

  const durations = [
    { value: 'all', label: 'Any Duration' },
    { value: 'short', label: '1-4 Days' },
    { value: 'medium', label: '5-7 Days' },
    { value: 'long', label: '8+ Days' }
  ];

  return (
    <div className="bg-gray-50 p-6 rounded-lg">
      <h3 className="text-lg font-semibold mb-4">Filter Retreats</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Retreat Type</label>
          <div className="relative">
            <select 
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 pr-8 cursor-pointer"
            >
              {types.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
            <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Duration</label>
          <div className="relative">
            <select 
              value={selectedDuration}
              onChange={(e) => setSelectedDuration(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 pr-8 cursor-pointer"
            >
              {durations.map((duration) => (
                <option key={duration.value} value={duration.value}>
                  {duration.label}
                </option>
              ))}
            </select>
            <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
          </div>
        </div>
      </div>
    </div>
  );
}
